import request from '@/helpers/request'

// auService have all api of user when not login
export default {
  async login(data) {
    return await request.post('users/login', data)
  },
  async register(data) {
    return await request.post('users/register', data)
  },
  // call when token expired
  async refreshToken(data) {
    return await request.post('users/refreshToken', data)
  },
  async forgotPassword(email) {
    return await request.post('users/reset_password', { email })
  },
  async changePassword(data) {
    return await request.put('users/reset_password', data)
  },
  async verifyEmail(data) {
    return await request.post('users/verify_email', data)
  },
  async verifyEmailCode(data) {
    return await request.post('users/verify_email_code', data)
  },
  async getUserInfo() {
    return await request.get('/users/fe_info')
  },
  async getUserPaymentInfo() {
    return await request.get('/users/payment_info')
  },
  async updateUserInfo(data) {
    return await request.put('/users/update_info', data)
  },
  async updateUserVisa(data) {
    return await request.put('/users/update_visa', data, { timeout: 15000 })
  },
  async withdrawSystem() {
    return await request.put('/users/withdraw')
  },
  async updateUserEmail(data) {
    return await request.put('/users/update_email', data)
  },
  async checkUpdateEmail(data) {
    return await request.put('/users/check-update-email', data)
  },
  async verifyPayment(data) {
    return await request.post('users/verify_payment', data)
  },
  async verifyCoupon(data) {
    return await request.post('users/verify_coupon', data)
  },
  async checkout(data) {
    return await request.post('users/checkout', data)
  },
  async updateStripePayment() {
    return await request.post('users/update_stripe_payment')
  },
  async getReasonKnow() {
    return await request.get('users/reason_know')
  },
  async checkEmailStatus(data) {
    return await request.post('users/email-status', data)
  },
  async updateTutorialCompleted() {
    return await request.post('users/tutorial_completed')
  },
  async getCsrfToken() {
    return await request.get('/csrf-token')
  }
}
